module.exports = __webpack_public_path__ + "static/media/start-bgm.e4c16965.mp3";